import SelectItem from '@/common/interfaces/SelectItem';

interface AgentItem {
  Agency: string;
  Agent: string;
  Address: string;
  Phone: string;
  Fax: string;
  Email?: string;
  Website?: string;
}

export interface SearchResult {
  Agents: AgentItem[];
  CurrentPage: number;
  AllPages: number;
  Total: number;
}

export interface FindTravelAgentBlockViewModel {
  Radiuses: SelectItem[];
  SortingOptions: SelectItem[];
}

export interface SearchModel {
  Zip: string;
  Distance: number;
  IsCanadian: boolean;
  Page: number;
  PageSize: number;
}

export interface SearchResultText {
  Result: string,
  NotFound: string
}

export const names = {
  Zip: 'Zip',
};
